import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { PageHeading, SubsectionHeading } from 'web-ui-components/lib/typography/headings';
import { NavigationButton, NavigationButtonGroup } from 'web-ui-components/lib/navigation/buttons';
import { ServicingSection } from 'web-ui-components/lib/global/layout';

import copPropTypes from '../../states/propTypes';
import { getCopyText } from '../../states/selectors';
import withContent from '../../../containers/withContent';
import copContent from '../Content/cop.content';
import { goToCOPPage, updateDetails } from '../../states/actions';
import { pages } from '../../../states/page/actions';
import { copAccountTypes } from '../../../config';
import { unsetAccountNameServicesError } from '../../../states/payees/actions';
import { getAccountNameServicesError } from '../../../managePayee/states/selectors';

const mapState = (state) => ({
	copyText: getCopyText(state),
	hasAccountNameServicesError: getAccountNameServicesError(state),
});

const mapDispatch = (dispatch) => ({
	handleUpdateDetails: () => dispatch(updateDetails),
	handleKeepAsIs: () => dispatch(goToCOPPage(pages.COP.AccountWarning)),
	handleRetry: () => dispatch(goToCOPPage(pages.COP.MakeMatch)),
	unsetAccountNameServicesError: () => dispatch(unsetAccountNameServicesError()),
});

export class ServiceDown extends Component {
	constructor(props) {
		super(props);

		this.handleEditDetails = this.handleEditDetails.bind(this);
		this.handleTryAgain = this.handleTryAgain.bind(this);
	}

	handleEditDetails() {
		const { handleEdit, payeeId, hasAccountNameServicesError, unsetAccountNameServicesError } = this.props;

		handleEdit(payeeId);

		if (hasAccountNameServicesError) {
			unsetAccountNameServicesError();
		}
	}

	handleTryAgain() {
		const { handleRetry, hasAccountNameServicesError, unsetAccountNameServicesError } = this.props;

		handleRetry();

		if (hasAccountNameServicesError) {
			unsetAccountNameServicesError();
		}
	}

	render() {
		const {
			content,
			copyText,
			handleCancel,
			handleKeepAsIs,
			setKeepAsIs,
			/**
			 * @todo We should just aim to accept an `accountType` prop rather than the more general,
			 * vague, copDetails object.
			 */
			copDetails: { accountType = copAccountTypes.Personal },
		} = this.props;
		const {
			editButtonText,
			keepButtonText,
			cancelButtonText,
			serviceDownHeading,
			serviceDownHeaderDetail,
			serviceDownFooter,
			retryButtonText,
			serviceDownFooterDetailBusiness,
			serviceDownFooterDetailPersonal,
		} = content;
		const payeeAccountType = copAccountTypes[accountType];

		const serviceDownFooterDetail =
			payeeAccountType === copAccountTypes.Business ? serviceDownFooterDetailBusiness : serviceDownFooterDetailPersonal;

		const contentCopyText = {
			heading: serviceDownHeading,
			header_detail: serviceDownHeaderDetail,
			footer: serviceDownFooter,
			footer_detail: serviceDownFooterDetail,
		};
		const { heading, header_detail, footer, footer_detail } = copyText || contentCopyText;

		const retryButton = <NavigationButton.Primary labelText={retryButtonText} onClick={this.handleTryAgain} />;
		const editButton = <NavigationButton.Secondary labelText={editButtonText} onClick={this.handleEditDetails} />;
		const keepAsIsButton = (
			<NavigationButton.Secondary
				labelText={keepButtonText}
				onClick={() => {
					setKeepAsIs(true);
					handleKeepAsIs();
				}}
				data-test-id="cop-service-down-keep-as-is-button"
			/>
		);
		const cancelButton = <NavigationButton.Tertiary labelText={cancelButtonText} onClick={handleCancel} />;

		return (
			<ServicingSection>
				<PageHeading data-test-id="service-down">{heading}</PageHeading>
				<p>{header_detail}</p>
				<SubsectionHeading>{footer}</SubsectionHeading>
				<p data-test-id="footer-detail-content">{footer_detail}</p>
				<NavigationButtonGroup
					primaryButton={keepAsIsButton}
					secondaryButtons={[retryButton, editButton]}
					tertiaryButtons={cancelButton}
				/>
			</ServicingSection>
		);
	}
}

ServiceDown.propTypes = {
	content: PropTypes.shape({}),
	handleCancel: PropTypes.func,
	handleEdit: PropTypes.func,
	handleKeepAsIs: PropTypes.func,
	copyText: PropTypes.shape({}),
	handleRetry: PropTypes.func,
	payeeId: PropTypes.string,
	copDetails: PropTypes.shape(copPropTypes),
};

const connectWrapper = connect(mapState, mapDispatch);
const contentWrapper = withContent({ content: copContent });

export default compose(connectWrapper, contentWrapper)(ServiceDown);
